const getImageUrl = (image) => {
  return 'https://static.nimax.ru' + image;
};
export default getImageUrl;
